"use strict";

var HtmlParser = '__RMD_HTML_PARSER__';
exports.HtmlParser = typeof Symbol === 'undefined' ? HtmlParser : Symbol(HtmlParser);


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-markdown/lib/symbols.js
// module id = 246
// module chunks = 0